import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of as ObservableOf } from 'rxjs/observable/of';
import { catchError, map } from 'rxjs/operators';
import { isNil as _isNil } from 'lodash';
import { IGenericFlagMgt } from '@blcloud/bl-datamodel';
import { BizcmnConst } from '@blcloud/bl-datamodel/const/bizcmn';
import { GenericFlagMgtResource } from '@blcloud/bl-ng-resource';

/**
 * 設定情報管理サービス
 */
@Injectable()
export class SettingManagementService {

  /**
   * 確定保存設定フラグ
   * true: 確定保存 / false: 下書き保存
   */
  private saveConfirmationFlag: boolean;

  constructor(
    private genericFlagMgtResource: GenericFlagMgtResource,
  ) {}

  /**
   * 確定保存設定ジェネリックフラグ管理情報取得
   * @return 未作成の場合は`null`を返します
   */
  getSaveConfirmationFlag(option = {force: false}): Observable<boolean> {
    const saveConfirmationKey = BizcmnConst.GENERICFLG_SAVE_CONFIRMATION;
    if (!_isNil(this.saveConfirmationFlag) && option.force === false) {
      return ObservableOf(this.saveConfirmationFlag);
    }
    return this.genericFlagMgtResource.getById<IGenericFlagMgt>(saveConfirmationKey).pipe(
      map((flagMgt: IGenericFlagMgt) => {
        this.saveConfirmationFlag = flagMgt.genericFlagValue;
        return flagMgt.genericFlagValue;
      }),
      catchError(err => {
        if (err.status === 404) {
          return ObservableOf(false);
        }
        throw err;
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/setting-management/setting-management.service.ts